module.exports = __webpack_public_path__ + "media/assets/images/aws_connect/affidabilita-66d744a83f3069dfd677ca819a9b997f.png";